/**
 * Where the inline "Read next" block goes in an article body.
 *
 * `kinds` is the body's top-level children, marked 'h2' for section headings
 * and 'other' for everything else; `ctaIndex` is where the mid-article CTA was
 * placed (-1 if none). Returns the index to insert before, or null to skip.
 *
 * - Short posts (under 12 blocks) are skipped: the Related Research grid is
 *   already close to where their readers are.
 * - Aim for 25% of the body, the last point 40% of readers reach, but never
 *   within 3 blocks of the CTA, so the two asks do not stack.
 * - Snap forward to just before the next h2 if one is within 4 blocks, so the
 *   block sits between sections instead of splitting one.
 * - Never later than 40% of the body.
 */
export function readNextInsertIndex(kinds: ReadonlyArray<'h2' | 'other'>, ctaIndex: number): number | null {
  const n = kinds.length
  if (n < 12) return null
  const ceiling = Math.floor(n * 0.4)
  const target = Math.max(ctaIndex + 3, Math.floor(n * 0.25))
  if (target > ceiling) return null
  for (let i = target; i <= Math.min(target + 4, ceiling); i++) {
    if (kinds[i] === 'h2') return i
  }
  return target
}
